import i18n from '@dms/i18n';

import {type OfferAlternative} from './OfferAlternative';

/** "Alternative B" or "Alternative B · Plug-in hybrid". */
export const getAlternativeLabel = (alternative: Pick<OfferAlternative, 'letter' | 'name'>) => {
  const label = i18n.t('entity.offerAlternative.label', {
    defaultValue: 'Alternative {letter}',
    letter: alternative.letter,
  });

  return alternative.name ? `${label} · ${alternative.name}` : label;
};
